import client from "../../../../common/client";

export const GET_GOLF_SCHOOLS = "GET_GOLF_SCHOOLS";
export const REGISTER_FOR_CLASS = "REGISTER_FOR_CLASS";
export const CONTACT_BRYAN = "CONTACT_BRYAN";

export const getGolfSchools = () => ({
  promise: client.get("schools"),
  type: GET_GOLF_SCHOOLS,
});

export const registerForClass = (userId, classId, payload) => ({
  promise: client.post(`users/${userId}/classes/${classId}`, payload),
  type: REGISTER_FOR_CLASS,
  classId,
});

export const contactBryan = (payload) => ({
  promise: client.post("schools/contact", payload),
  type: CONTACT_BRYAN,
});



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/redux/actions.js